export const BASESTATION_API = '/tractor-indicators';
export const CATEGORIES_API = '/knowledgebase-viewer/category-data';
export const SEARCH_ARTICLE_API = '/knowledgebase-viewer/search';
export const SUBCATEGORIES_API = '/knowledgebase-viewer/subcategory-data';
export const ARTICLE_API = '/knowledgebase-viewer/article-data';
export const FAQ_API = '/knowledgebase-viewer/faq';
export const FLEET_INDICATORS_API = '/knowledgebase-viewer/fleet-indicator';
export const FREQUENT_SEARCHES_API = '/knowledgebase-viewer/frequent-data';
export const COVERAGE_RANGE_API = '/analytics/radio-coverage-range';
